import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      {/* Top strip */}
      <div className="h-1 bg-gradient-to-r from-blue-800 via-blue-500 to-blue-700" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="w-16 h-16 flex items-center justify-center overflow-hidden">
                {/* Photo - Adjust w-12 h-12 for size */}
                <img
                  src="IMG_1656.PNG"
                  alt="Load2Serve Logo"
                  className=" object-cover"
                  style={{ maxWidth: "7rem", maxHeight: "6rem" }}
                />
              </div>
              <span className="text-2xl font-black tracking-tight">
              <span className="text-[#1c7abb]">Load</span>
              <span className=" text-[#0f522d]">2Serve</span>
            </span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed mb-5">
              Your trusted partner for global freight and logistics solutions.
              Moving cargo across borders — reliably, efficiently, securely.
            </p>
            {/* Social icons */}
            {/* <div className="flex gap-3">
              {["linkedin", "twitter", "facebook"].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-blue-700 flex items-center justify-center transition-colors duration-200"
                  aria-label={social}
                >
                  <svg
                    className="w-4 h-4 text-slate-400 hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <circle cx="12" cy="12" r="6" />
                  </svg>
                </a>
              ))}
            </div> */}
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: "Home", path: "/" },
                { label: "Get a Quote", path: "/quote" },
                { label: "Contact Us", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-slate-400 hover:text-blue-400 transition-colors duration-200 flex items-center gap-1.5 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-blue-600 group-hover:bg-blue-400 transition-colors" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
              Services
            </h4>
            <ul className="space-y-2.5">
              {[
                "Freight Forwarding",
                "Warehousing",
                "Transportation",
                "Customs Clearance",
              ].map((s) => (
                <li key={s}>
                  <span className="text-sm text-slate-400 flex items-center gap-1.5">
                    <span className="w-1 h-1 rounded-full bg-blue-600" />
                    {s}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-widest">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <svg
                  className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-sm text-slate-400">
                  6202 Healy RdCaledon East, On L7C0W7
                </span>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="w-4 h-4 text-blue-400 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href="mailto:info@Load2Serve.com"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  info@load2serve.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <svg
                  className="w-4 h-4 text-blue-400 flex-shrink-0"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href="tel:+912212345678"
                  className="text-sm text-slate-400 hover:text-blue-400 transition-colors"
                >
                  +1 (343) 265-0527
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {year} Load2Serve Logistics Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex gap-5">
            {/* {["Privacy Policy", "Terms of Service"].map((item) => (
              <a
                key={item}
                href="#"
                className="text-xs text-slate-500 hover:text-slate-300 transition-colors"
              >
                {item}
              </a>
            ))} */}
          </div>
        </div>
      </div>
    </footer>
  );
}
